import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  ContentProvider,
  PageContainer,
  PageHeader,
} from '../content/components';
import {
  ColumnBlock,
  ColumnContent,
  ContentSection,
} from '../layout/components';
import { LanguageSelector } from './components';

class GenericPage extends Component {
  static propTypes = {
    slug: PropTypes.string.isRequired,
  };

  render() {
    const { slug } = this.props;

    return (
      <ContentProvider
        slug={`static-pages/${slug}`}
        render={({ title, page, typography, translation_links }) => (
          <PageContainer typography={typography}>
            <PageHeader
              subpage
              title={title}
              subtitle=""
              mainImage={page.main_image}
            />

            <ContentSection>
              <ColumnBlock columns={1} />
              <ColumnBlock columns={2}>
                <ColumnContent paddingTop="4.5rem" paddingBottom="4.5rem">
                  {translation_links && (
                    <LanguageSelector items={translation_links} slug={slug} />
                  )}
                  <div
                    id="page-content"
                    dangerouslySetInnerHTML={{ __html: page.body }}
                  />
                </ColumnContent>
              </ColumnBlock>
            </ContentSection>
          </PageContainer>
        )}
      />
    );
  }
}

const mapStateToProps = (state, { match: { params } }) => {
  const { slug } = params;
  return {
    slug,
  };
};

export default withRouter(connect(mapStateToProps, null)(GenericPage));



// WEBPACK FOOTER //
// ./src/modules/pages/GenericPage.js